import { httpGet, httpPost } from '../../../utils/api.utils';
import { getLocalTimeZone } from '../../../utils/helpers.utils';
import { ORDER_AUDIT_TYPES, ORDER_STATUS as OrderStatus, NOTIFICATION_NAME_KEY } from '../../../../app/constants/external-constants';

import {
    updateRequestDetailModel
    , updateRequestDetailIsError
    , updateSelectedRequest
    , setExhibitType
    //progress
    , updateRequestProgressData
    , setPageSize
    , setReadMoreLoading
    , setErrorLoading
    //comment
    , setErrorComments
    , updateCommentData
    , setCommentPageSize
    , setCommentData
    , resetCommentData
    //approve & reject
    , setApproverData
    , updateOrderStatus
    , setRejectionComment
    , showHideRejectComment
    , showDecisionButton
    , setBusinessHoursNotice
    , updateOrderRequest
} from '../../../constants/model-reducers/external/request/request-details.settings';

let defaultPageSize = 10;

const initialState = {
    selectedItem: {}
    , exhibitType: 0
    , isQuotation: false
    , requestData: {}
    , isLoaded: false
    , isError: false
    //progress details
    , requestMilestones: {}
    , requestActivities: {}
    , pageSize: defaultPageSize
    , isProgressReadMore: false
    , isProgressLoaded: false
    , isProgressError: false
    //comment details
    , requestComments: {}
    , commentData: ''
    , commentPageSize: defaultPageSize
    , isCommentReadMore: false
    , isCommentLoaded: false
    , isCommentError: false
    //approve & reject
    , approverData: {}
    , isApproverLoaded: false
    , isRejectDisabled: true
    , showRejectionCommentBox: false
    , showDecisionButtons: false

    , businessHoursNotice: ""
};

export const requestDetailsActions = {
    setSelectedRequest: (obj, isQuotation = false) => dispatch => {
        dispatch({
            type: updateSelectedRequest
            , data: obj
            , isQuotation: isQuotation
        });
    }
    , getExhibitType: () => async (dispatch, state) => {
        const { selectedItem } = state().requestDetail;
        var requestTypeId = selectedItem != null || Object.keys(selectedItem).length > 0 ? selectedItem.RequestTypeId : 0;

        var res = await httpGet('external/orderRequest/getRequestDetailsDisplay?id=' + requestTypeId);

        if (res != null) {
            dispatch({ type: setExhibitType, data: res.exhibit })
        }

        return Promise.resolve(true);
    }
    , fetchRequestDetails: () => async (dispatch, state) => {
        const { selectedItem, isQuotation } = state().requestDetail;
        var orderId = selectedItem != null || Object.keys(selectedItem).length > 0 ? selectedItem.OrderId : 0;
        var requestTypeId = selectedItem != null || Object.keys(selectedItem).length > 0 ? selectedItem.RequestTypeId : 0;
        var url = isQuotation
            ? 'external/requestdetail/getQuotationDetails?quotationRequestId=' + orderId
            : 'external/requestdetail/getDetails?orderid=' + orderId + '&requestTypeId=' + requestTypeId;

        dispatch({
            type: updateRequestDetailModel,
            data: {},
            isLoaded: false
        });

        var newRequestModel = await httpGet(url);
        if (newRequestModel.ok === false || newRequestModel == null || Object.keys(newRequestModel).length === 0) {
            dispatch({
                type: updateRequestDetailIsError,
                isError: true,
                isLoaded: true
            });
        } else {
            await getBusinessHoursNotice(dispatch);

            dispatch({
                type: updateRequestDetailModel,
                data: newRequestModel,
                isLoaded: true
            });
        }
    }
    , fetchRequestProgress: (isReadMore) => async (dispatch, state) => {
        const { selectedItem, pageSize, isQuotation } = state().requestDetail;
        var currentPageSize = pageSize;

        if (isReadMore) {
            currentPageSize = currentPageSize + 10;
            dispatch({ type: setPageSize, pageSize: currentPageSize });
        }
        var orderId = selectedItem != null || Object.keys(selectedItem).length > 0 ? selectedItem.OrderId : 0;
        requestProgress(orderId, currentPageSize, isQuotation === true, dispatch)
    }
    , fetchOrderComments: (isReadMore) => async (dispatch, state) => {
        const { selectedItem, commentPageSize, isQuotation } = state().requestDetail;
        var orderId = selectedItem != null || Object.keys(selectedItem).length > 0 ? selectedItem.OrderId : 0;
        var user = JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId;
        var currentPageSize = commentPageSize;
        if (isReadMore) {
            currentPageSize = currentPageSize + 10;
            dispatch({ type: setCommentPageSize, commentPageSize: currentPageSize });
        }
        var urlOrders =
            'external/ordercomments/getOrderComments?orderID=' + orderId
            + '&userName=' + user
            + '&pageSize=' + currentPageSize
            + '&timeZone=' + getLocalTimeZone();
        var urlQuotation =
            'external/ordercomments/geQuotationComments?orderID=' + orderId
            + '&pageSize=' + currentPageSize
            + '&timeZone=' + getLocalTimeZone();

        var commentsModel = await httpGet(isQuotation === true ? urlQuotation : urlOrders);
        if (commentsModel.ok === false) {
            dispatch({
                type: setErrorComments,
                isError: true,
                isLoaded: true
            });
        } else {
            dispatch({
                type: updateCommentData,
                data: commentsModel.OrderCommentsModels,
                isLoadedReadMore: commentsModel.HasMorePage,
                isLoaded: true
            });
        }
    },

    deleteOrderRequestComment: (commentId) => async (dispatch, state) => {
        var res = await httpPost('external/ordercomments/OrderRequestDeleteComment?timeZone=' 
            + getLocalTimeZone()
            + '&commentID=' 
            + commentId);

        if (res == null) {
            dispatch({
                type: setErrorComments,
                isError: true,
                isLoaded: true
            });
        }
    }

    , fetchOwnerApproverDetails: () => async (dispatch, state) => {
        const { selectedItem, isQuotation } = state().requestDetail;
        var orderId = selectedItem != null || Object.keys(selectedItem).length > 0 ? selectedItem.OrderId : 0;

        var urlOrders = 'external/requestDetail/getOwnerApprover?orderId=' + orderId
            + '&empId=' + sessionStorage.EmployeeID
            + '&isRequestCreation=' + false;
        var urlQuotation = 'external/requestDetail/getQuotationOwnerApprover?userId=' + selectedItem.EndUserId;

        dispatch({ type: setApproverData, data: {}, isLoaded: true });

        var ownerApprover = await httpGet(isQuotation ? urlQuotation : urlOrders);

        if (ownerApprover.ok === false) {
            dispatch({ type: setApproverData, data: {}, isLoaded: false });
        } else {
            dispatch({ type: setApproverData, data: ownerApprover, isLoaded: false});
        }
    }
    , handleApprovalSubmission: () => async (dispatch, state) => {
        const { selectedItem, isQuotation } = state().requestDetail;
        var item = { ...selectedItem}
        var data = {
            OrderId: item.OrderId,
            UserId: JSON.parse(sessionStorage.getItem('User')).Employee.UserId,
            RoleId: JSON.parse(sessionStorage.getItem('User')).Employee.Role.RoleId,
            EmployeeId: JSON.parse(sessionStorage.getItem('User')).Employee.EmployeeId,
            EnterPriseId: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            Comment: '',
            Action: ORDER_AUDIT_TYPES.approveOrder,
            IsCostCodeAuthorizer: sessionStorage.IsCostCodeAuthorizer
        };
        var requestExecution = await httpPost('external/requestDetail/handleDecision', data);
        if (requestExecution.IsSuccess) {
            item.OrderStatusId = requestExecution.OrderStatusId;
            item.IsFirstLMApproved = true;
            dispatch({
                type: updateSelectedRequest
                , data: item
                , isQuotation: isQuotation
            });
        }

        return requestExecution;
    }
    , handleRejectionCommentSubmission: (item, rejectReason) => async (dispatch, state) => {
        var data = {
            OrderId: item.OrderId,
            UserId: JSON.parse(sessionStorage.getItem('User')).Employee.UserId,
            employeeId: JSON.parse(sessionStorage.getItem('User')).Employee.EmployeeId,
            RoleId: JSON.parse(sessionStorage.getItem('User')).Employee.Role.RoleId,
            EnterPriseId: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            Comment: rejectReason,
            Action: ORDER_AUDIT_TYPES.rejectOrder,
            IsCostCodeAuthorizer: sessionStorage.IsCostCodeAuthorizer
        };

        var requestExecution = await httpPost('external/requestDetail/handleDecision', data);

        if (requestExecution.IsSuccess) {
            item.OrderStatusId = requestExecution.OrderStatusId;
            item.IsFirstLMApproved = true;
            dispatch({
                type: updateOrderStatus,
                item: item
            });
            dispatch({
                type: showHideRejectComment,
                showRejectionCommentBox: false
            });
        }

        return requestExecution;
    }
    , setRejectionComment: e => dispatch => {
        const target = e.target;
        const value = target.value;

        var rejectComment = value;
        var isRejectDisabled = validateRejectComment(value);
        dispatch({
            type: setRejectionComment,
            rejectComment: rejectComment,
            isRejectDisabled: isRejectDisabled
        });
    }
    , handleRejectionClick: () => (dispatch, state) => {
        dispatch({
            type: showHideRejectComment,
            showRejectionCommentBox: true
        });
    }
    , handleCancelRejectionClick: () => (dispatch, state) => {
        dispatch({
            type: showHideRejectComment,
            showRejectionCommentBox: false
        });
    }
    , handleCancelSubmission: () => async (dispatch, state) => {
        const { selectedItem, isQuotation } = state().requestDetail;
        var data = {
            OrderId: selectedItem.OrderId,
            UserId: JSON.parse(sessionStorage.getItem('User')).Employee.UserId,
            RoleId: JSON.parse(sessionStorage.getItem('User')).Employee.Role.RoleId,
            EnterPriseId: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            Action: ORDER_AUDIT_TYPES.cancelOrder,
            IsQuotationReq: isQuotation
        };
        var requestExecution = await httpPost('external/requestDetail/handleCancellation', data);
        if (requestExecution.IsSuccess) {
            selectedItem.CanEdit = false;
            selectedItem.OrderStatusId = OrderStatus.canceled;
            selectedItem.IsFirstLMApproved = true;
            dispatch({
                type: updateSelectedRequest
                , data: selectedItem
                , isQuotation: isQuotation
            });

        }

        return requestExecution;
    }
    , handleApproveSubmission: () => async (dispatch, state) => {
        const { selectedItem, isQuotation } = state().requestDetail;
        var data = {
            OrderId: selectedItem.OrderId,
            UserId: JSON.parse(sessionStorage.getItem('User')).Employee.UserId,
            RoleId: JSON.parse(sessionStorage.getItem('User')).Employee.Role.RoleId,
            EnterPriseId: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            Action: ORDER_AUDIT_TYPES.approveOrder,
            IsQuotationReq: isQuotation
        };
        var requestExecution = await httpPost('external/requestDetail/handleApproval', data);
        if (requestExecution.IsSuccess) {
            selectedItem.CanEdit = false;
            selectedItem.OrderStatusId = OrderStatus.approved;
            selectedItem.IsFirstLMApproved = true;
            dispatch({
                type: updateSelectedRequest
                , data: selectedItem
                , isQuotation: isQuotation
            });

        }

        return requestExecution;
    }
    , handleRejectSubmission: () => async (dispatch, state) => {
        const { selectedItem, isQuotation } = state().requestDetail;
        var data = {
            OrderId: selectedItem.OrderId,
            UserId: JSON.parse(sessionStorage.getItem('User')).Employee.UserId,
            RoleId: JSON.parse(sessionStorage.getItem('User')).Employee.Role.RoleId,
            EnterPriseId: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            Action: ORDER_AUDIT_TYPES.rejectOrder,
            IsQuotationReq: isQuotation
        };
        var requestExecution = await httpPost('external/requestDetail/handleReject', data);
        if (requestExecution.IsSuccess) {
            selectedItem.CanEdit = false;
            selectedItem.OrderStatusId = OrderStatus.rejected;
            selectedItem.IsFirstLMApproved = true;
            dispatch({
                type: updateSelectedRequest
                , data: selectedItem
                , isQuotation: isQuotation
            });

        }

        return requestExecution;
    }
    , isApprovedOrRejected: item => async (dispatch, state) => {
        var orderId = item != null || Object.keys(item).length > 0 ? item.OrderId : 0;
        var employeeId = JSON.parse(sessionStorage.getItem('User')).Employee.EmployeeId;
        var isApprovedOrRejected = await httpGet(
            'external/requestDetail/isApprovedOrRejected?orderId=' + orderId + '&employeeId=' + employeeId
        );
        dispatch({ type: showDecisionButton, showDecisionButtons: isApprovedOrRejected });
    }
    , setCommentData: e => async (dispatch, state) => {
        const target = e.target;
        const value = target.value;

        dispatch({
            type: setCommentData,
            data: value
        });
    }
    , resetCommentData: ()=>({
        type: resetCommentData
    })
    , submitComment: () => async (dispatch, state) => {
        const { selectedItem, isQuotation, commentData, commentPageSize } = state().requestDetail;
        var orderId = selectedItem != null || Object.keys(selectedItem).length > 0 ? selectedItem.OrderId : 0;
        var user = JSON.parse(sessionStorage.getItem('User'));
        var data;

        if (commentData !== '') {
            data = {
                orderId: orderId
                , comment: commentData
                , createdBy: user.Employee.EnterpriseId
                , userId: user.Employee.UserId
                , pageSize: commentPageSize
            };
        } else {
            return;
        }

        var res = isQuotation
            ? await httpPost('external/ordercomments/addQuotationComments?timeZone=' + getLocalTimeZone(), data)
            : await httpPost('external/ordercomments/addOrderComments?timeZone=' + getLocalTimeZone(), data);

        if (res.ok === false) {
            return false;
        } else {
            dispatch({
                type: setCommentData,
                data: initialState.commentData
            });
            return true;
        }
    }
    , updateOrderRequest: val => dispatch => {
        dispatch({ type: updateOrderRequest, data: val });
    }
}

async function getBusinessHoursNotice(dispatch) {
    var res = await httpGet(`external/requestDetail/getNotificationMessage/${NOTIFICATION_NAME_KEY.operationBusinessHours}`);

    dispatch({
        type: setBusinessHoursNotice,
        data: res.data
    });
}

function validateRejectComment(rejectComment) {
    if (rejectComment === '') return true;
    return false;
}

async function requestProgress(orderId, currentPageSize, isQuotationReq, dispatch) {
    var url = 'external/requestProgress/getRequestProgress?orderid=' + orderId
        + '&pageSize=' + currentPageSize
        + '&timeZone=' + getLocalTimeZone()
        + '&isQuotationReq=' + isQuotationReq;
    dispatch({ type: setReadMoreLoading, loaded: false });
    var res = await httpGet(url);
    if (res.ok === false) {
        dispatch({
            type: setErrorLoading,
            isError: true,
            isLoaded: true
        });
    } else {
        var displayOrderAudit = !res.HaveAllOrderAudit;
        dispatch({
            type: updateRequestProgressData,
            requestMilestones: res.MilestoneModel,
            requestActivities: res.OrderAuditKeyValueModel,
            isLoaded: true,
            isLoadedReadMore: displayOrderAudit
        });
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setBusinessHoursNotice:
            return {
                ...state,
                businessHoursNotice: action.data
            };
        case updateRequestDetailModel:
            return {
                ...state,
                requestData: {
                    ...action.data
                },
                isLoaded: action.isLoaded
            };
        case updateRequestDetailIsError:
            return {
                ...state,
                isError: action.isError,
                isLoaded: action.isLoaded
            };
        case updateSelectedRequest:
            return {
                ...state,
                selectedItem: action.data
                , isQuotation: action.isQuotation
            };
        case setExhibitType:
            return {
                ...state,
                exhibitType: action.data
            };
        case updateRequestProgressData:
            return {
                ...state,
                requestActivities: {
                    ...action.requestActivities
                },
                requestMilestones: action.requestMilestones,
                isProgressLoaded: action.isLoaded,
                isProgressReadMore: action.isLoadedReadMore
            };
        case setPageSize:
            return {
                ...state,
                pageSize: action.pageSize
            };
        case setCommentPageSize:
            return {
                ...state,
                commentPageSize: action.commentPageSize
            };
        case setReadMoreLoading:
            return {
                ...state,
                isProgressReadMore: action.loaded
            };
        case setErrorLoading:
            return {
                ...state,
                isProgressError: action.isError,
                isProgressLoaded: action.isLoaded
            };
        case setErrorComments:
            return {
                ...state,
                isCommentLoaded: action.isLoaded,
                isCommentError: action.isError
            };
        case resetCommentData:
            return {
                ...state,
                commentData: ''
            }
        case updateCommentData:
            return {
                ...state,
                requestComments: action.data,
                isCommentLoaded: action.isLoaded,
                isCommentError: action.isLoadedReadMore
            };
        case setCommentData:
            return {
                ...state,
                commentData: action.data
            }
        case setApproverData:
            return {
                ...state,
                approverData: action.data,
                isApproverLoaded: action.isLoaded
            };
        case updateOrderStatus:
            return {
                ...state,
                item: {
                    ...action.item
                }
            };
        case setRejectionComment:
            return {
                ...state,
                rejectComment: action.rejectComment,
                isRejectDisabled: action.isRejectDisabled
            };
        case showHideRejectComment:
            return {
                ...state,
                showRejectionCommentBox: action.showRejectionCommentBox
            };
        case showDecisionButton:
            return {
                ...state,
                showDecisionButtons: action.showDecisionButtons
            };
        case updateOrderRequest:
            return {
                ...state,
                isAmending: action.data
            };
        default: return state;
    }
}


